import { components } from "@appretio/api";
import { ContextSelectedOptions } from "@appretio/context-selector";
import { SortModelItem } from "ag-grid-enterprise";
import { TemporalContext } from "../../../components/temporalContextSelector/data/temporalContextOptions";
import { removeUndefined } from "./removeUndefined";

export function convertOptionsToApiFormat(
  contextOptions: ContextSelectedOptions,
  temporalOptions: TemporalContext
) {
  // Split context options into different contexts
  const styleContext: components["schemas"]["StyleContext"] = {
    brand: contextOptions.brand,
    sub_brand: contextOptions.sub_brand,
    product_line: contextOptions.product_line,
    collection_type: contextOptions.collection_type,
    product_category: contextOptions.product_category
  };

  const transactionContext: components["schemas"]["TransactionContext"] = {
    chain: contextOptions.chain,
    sales_location: contextOptions.sales_location,
    country: contextOptions.country,
    channel: contextOptions.channel
  };

  const styleAssociatedContext: components["schemas"]["StyleAssociatedContext"] =
    {
      collection_name: contextOptions.collection_name
    };

  const request = {
    temporal_context: temporalOptions,
    style_context: removeUndefined(styleContext),
    transaction_context: removeUndefined(transactionContext),
    style_associated_context: removeUndefined(styleAssociatedContext)
  };

  return request;
}

export function convertSortingToApiFormat(sorting: SortModelItem[]) {
  if (!sorting || sorting.length === 0) {
    return undefined;
  }

  return sorting.map((sortItem: SortModelItem) => ({
    column: sortItem.colId,
    direction: sortItem.sort
  }));
}
